var path = '@collectivehealth/get-care/components/starRating/starRating.html';
var html = "<div class=\"StarRating\">\n  <gc-value-scale value=\"StarRating.rating\" max=\"3\">\n    <dls-icon-star></dls-icon-star>\n  </gc-value-scale>\n</div>\n";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;